import { weekDays } from 'pages/NewsletterPage/const';

export const dateRangeOptions = new Array(30).fill(0).map((_, i) => ({
  value: i + 1,
  label: `${i + 1} jour${!i ? '' : 's'}`,
}));

export const articleNumberOptions = new Array(41).fill(0).map((_, i) => ({
  value: i,
  label: i,
}));

export const JSONStringifyReplacer = (
  _: string,
  value: Record<string, unknown>,
) => {
  const hasValue = (currValue: any) => {
    if (Array.isArray(currValue)) {
      return Boolean(currValue.length);
    }

    return currValue !== undefined && currValue !== null;
  };

  if (typeof value === 'object') {
    if (value && Object.values(value).filter(hasValue).length) {
      return value;
    }

    return undefined;
  } else if (hasValue(value)) {
    return value;
  }

  return undefined;
};

export const getWeekDaysSuggestions = (paramAvailableWeekDays: any) => {
  const availableWeekDays = paramAvailableWeekDays
    ? paramAvailableWeekDays.map(
        (availableWeekDay: any) => availableWeekDay.label,
      )
    : [];
  const suggestions = weekDays
    .filter((weekDay) => !availableWeekDays.includes(weekDay))
    .reduce((acc: any[], weekDay) => {
      // eslint-disable-next-line fp/no-mutating-methods
      acc.push({
        id: weekDays.indexOf(weekDay),
        label: weekDay,
      });

      return acc;
    }, []);

  return suggestions;
};
